const PORTFOLIO_WALKTHROUGH = {
  steps: [
    {
      title: "Navigate to Portfolios",
      target: ".wt-nav-portfolio",
      placement: "auto",
      content: "Click to navigate to Portfolios page to start",
    },
    {
      title: "Connect Broker Account",
      target: ".button-wrapper",
      placement: "auto",
      content: "Click '+ Connect Porfolio' button to begin",
    },
    {
      title: "Broker List",
      target: ".broker-list",
      placement: "auto",
      content:
        "Selecting any of listed brokers will redirect you to broker account service and will take you back here with the connected account",
    },
  ],
};

export const WALKTHROUGH = {
  "link-portfolio": PORTFOLIO_WALKTHROUGH,
};
